// src/components/BulletList.jsx
import React from "react";
import { List, ListItem, ListItemText } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const BulletList = ({ items = [] }) => {
  const theme = useTheme();

  return (
    <List
      sx={{
        listStyleType: "disc",
        pl: 4,
        color: "text.primary",
      }}
    >
      {items.map((item, index) => (
        <ListItem
          key={index}
          sx={{
            display: "list-item",
            py: 0,
            px: 0.5,
            "&::marker": {
              color: theme.palette.primary.main,
            },
          }}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </List>
  );
};

export default BulletList;
